import type { TableBodyProps as ChakraTableBodyProps } from '@chakra-ui/react';
import { Tbody as ChakraTbody } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type TableBodyProps = OmitChakraProps<ChakraTableBodyProps>;

export const Tbody = withChakraAs<TableBodyProps, 'tbody'>((props) => {
  return <ChakraTbody {...props} />;
});
